//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { lastValueFrom, map, Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { TariffUsageSchemeDTO } from 'src/app/core/models/system/tariff/tariff-usage-scheme.dto';

@Injectable({ providedIn: 'root' })

export class TariffsUsageSchemeService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public getById(id: number): Observable<TariffUsageSchemeDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.TariffsUsageSchemes +
                                                                  "?idEncSS=" + idEncSS, undefined);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TariffUsageSchemeDTO[]>(environment.eSimApi +
                                                                eSimApiPaths.TariffsUsageSchemes + "/" +
                                                                eSimApiPaths.TariffsUsageSchemesGetTariffsUsageSchemes)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(tariffUsageScheme: TariffUsageSchemeDTO) {
    return {id: tariffUsageScheme.id, description: tariffUsageScheme.schemeName};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
  
  public post(tariffUsageScheme: TariffUsageSchemeDTO): Observable<TariffUsageSchemeDTO> {
    try {
      //JSON.stringify(tariffUsageScheme)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(tariffUsageScheme))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.TariffsUsageSchemes +
                                                               "?objectEnc=" + objectEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public put(tariffUsageScheme: TariffUsageSchemeDTO): Observable<TariffUsageSchemeDTO> {
    try {
      //JSON.stringify(tariffUsageScheme)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(tariffUsageScheme))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.TariffsUsageSchemes +
                                                              "?id=" + tariffUsageScheme.id +
                                                              "&objectEnc=" + objectEnc, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
        
  public save(tariffUsageScheme: TariffUsageSchemeDTO): Observable<any> {
    try {
      //JSON.stringify(tariffUsageScheme);

      if (tariffUsageScheme.id && <number>tariffUsageScheme.id>0)
        return this.put(tariffUsageScheme);
      
      return this.post(tariffUsageScheme);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
